<div class="home-page">
    <div class="hero home-hero" #hero>
        <div class="hero__eyebrow">Welcome to</div>
        <h1 class="hero__title">Screen For EPI in CP</h1>
        <p class="hero__copy">Exocrine pancreatic insufficiency (EPI) is the deficiency of exocrine pancreatic enzymes resulting in the inability to maintain normal digestion, with abdominal and bowel symptoms such as steatorrhea, nausea, bloating, diarrhea, and unexplained weight loss.<sup>1,2</sup></p>
        <div class="horizontal-block">
            <app-button path="what-is-epi" text="Discover more" (btnClick)="track('home-discover-more-hero-button')"></app-button>
            <app-button path="screening-tool-landing" tab="start-screening" text="Start screening" variation="button--white" (btnClick)="track('home-start-screening-hero-button')"></app-button>
        </div>
    </div>
    <!-- CTA - About this tool -->
    <div class="cta cta--about">
        <div class="c-img">
            <picture class="cta__image">
                <source media="(max-width: 360px)" srcset="assets/images/ctas/the-screen-for-epi-in-cp-tool-mobile.jpg">
                <source media="(max-width: 719px)" srcset="assets/images/ctas/the-screen-for-epi-in-cp-tool-mobile@2x.jpg">
                <source media="(max-width: 1440px)" srcset="assets/images/ctas/the-screen-for-epi-in-cp-tool-full-height.png">
                <source media="(max-width: 2880px)" srcset="assets/images/ctas/the-screen-for-epi-in-cp-tool-full-height@2x.png">
                <img src="assets/images/ctas/the-screen-for-epi-in-cp-tool-full-height@3x.png" alt="About this tool image">
            </picture>
        </div>
        <div class="cta__info">
            <h2 class="cta__title">About this tool</h2>
            <p class="cta__text">The Screen for EPI in CP tool has been developed with leading pancreatology experts to help US healthcare professionals evaluate patients with definite chronic pancreatitis (CP) who may have EPI.</p>
            <app-button path="screening-tool-landing" text="Discover more" (btnClick)="track('home-about-this-tool-discover-more-button')"></app-button>
        </div>
    </div>
    <!-- CTA - The landscape -->
    <div class="cta cta--landscape cta--grey">
        <picture class="cta__image">
            <source media="(max-width: 360px)" srcset="assets/images/ctas/the-epi-landscape-mobile.png">
            <source media="(max-width: 719px)" srcset="assets/images/ctas/the-epi-landscape-mobile@2x.png">
            <source media="(max-width: 1440px)" srcset="assets/images/ctas/the-epi-landscape-desktop.png">
            <source media="(max-width: 2880px)" srcset="assets/images/ctas/the-epi-landscape-desktop@2x.png">
            <img src="assets/images/ctas/the-epi-landscape-desktop@3x.png" alt="About this tool image">
        </picture>
        <div class="cta__info">
            <h2 class="cta__title">The landscape</h2>
            <p class="cta__text">There is currently no simple and specific diagnostic test available for EPI, leading to underdiagnosis. Several different tests can be utilized by physicians to help identify patients with EPI, however these tests are often invasive, cumbersome and time consuming, or not widely available.<sup>3-5</sup></p>
            <app-button path="what-is-epi" text="What is EPI?" (btnClick)="track('home-the-landscape-what-is-epi-button')"></app-button>
        </div>
    </div>
    <!-- CTA - Designed to support US healthcare professionals -->
    <div class="cta cta--hcp">
        <div class="cta__image">
            <picture>
                <source media="(max-width: 360px)" srcset="assets/images/ctas/supporting-us-healthcare-professionals-mobile.jpg">
                <source media="(max-width: 719px)" srcset="assets/images/ctas/supporting-us-healthcare-professionals-mobile@2x.jpg">
                <source media="(max-width: 1440px)" srcset="assets/images/ctas/supporting-us-healthcare-professionals-desktop.png">
                <source media="(max-width: 2880px)" srcset="assets/images/ctas/supporting-us-healthcare-professionals-desktop@2x.png">
                <img src="assets/images/ctas/supporting-us-healthcare-professionals-desktop@3x.png" alt="">
            </picture>
        </div>
        <div class="cta__info">
            <h2 class="cta__title">Designed to support US healthcare professionals</h2>
            <p class="cta__text p-line"><span>The Screen For EPI in CP tool</span> was designed to support decisions of US healthcare professionals treating patients with definite CP who may be at risk for EPI.</p>
            <p class="cta__text">The tool is not a diagnostic test for EPI, and is not designed to provide any treatment recommendations for patients.</p>
            <app-button path="screening-tool-landing" tab="start-screening" text="Start screening" (btnClick)="track('home-designed-to-support-start-screening-button')"></app-button>
        </div>
    </div>
    <app-bottom-navigation continueRoute="what-is-epi" continueText="What is EPI?"></app-bottom-navigation>
    <app-references [references]="['Stuyvenberg', 'DiMagno', 'Hart', 'Working', 'Lindkvist']"></app-references>
</div>

